export default "/assets/Icon/Instagram.svg"